import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SessionStorageService } from '@df/browser/storage/session-storage.service';
import { OffClickModule } from '@df/module-off-click/off-click.module';
import { SearchComponentDef } from '@df/search/search.component.def';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
const SESSION_STORAGE_FLAG_NAME = 'searchTerm';
@Component({
    selector: 'search',
    templateUrl: './search.html',
    styleUrls: ['./search.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [FormsModule, OffClickModule, CommonModule, SizeClassDirective]
})
export class SearchComponent extends SearchComponentDef implements OnInit, AfterViewInit, OnDestroy {
    private sessionStorageService = inject(SessionStorageService);
    override ngOnInit() {
        super.ngOnInit();
        this.subscriptions.add(
            this.app.events.on('search.focus').subscribe(() => {
                this.isFocus = true;
            })
        );
        this.subscriptions.add(this.app.events.on('search.reset').subscribe(() => this.reset()));
        this.subscriptions.add(this.status.subscribe(() => this.detectChanges()));
        this.subscriptions.add(this.searchService.subscribeToSearch(() => this.detectChanges()));
    }
    override ngOnDestroy() {
        super.ngOnDestroy();
        this.reset();
    }
    ngAfterViewInit() {
        this.input?.nativeElement.focus();
    }
    override reset() {
        super.reset();
        this.app.events.broadcast('search.open', false);
    }
    close() {
        super.isFocus = false;
        this.app.events.broadcast('search.open', false);
    }
    keyup(event: KeyboardEvent) {
        this.sessionStorageService.set(SESSION_STORAGE_FLAG_NAME, this.term);
        if (event.key === 'Enter' || event.code === 'Enter') {
            this.input?.nativeElement.blur();
            this.goToSearch();
        }
    }
}
